import api from '@/api';

export default {
  namespaced: true,

  state: {
    allChartSettings: [],
  },

  getters: {
    chartSettings: (state) => {
      return (measuringPointId, chart) => {
        return state.allChartSettings.filter((item) => {
          return item.measuringPointId === measuringPointId && item.chart === chart;
        });
      };
    },
  },

  actions: {
    async GetChartSettings({ commit, getters }, { measuringPointId, chart }) {
      // 先从已有数据中查找
      let chartSettings = getters.chartSettings(measuringPointId, chart);
      if (chartSettings && chartSettings.length) return chartSettings;

      chartSettings = (await api.chartSetting
        .getChartSettings({ measuringPointId, chart })).chartSettings;
      // 合并图表配置项
      commit('MERGE_CHART_SETTINGS', chartSettings);
      return chartSettings;
    },
    async UpdateChartSettings({ commit }, { measuringPointId, chart, configs }) {
      const { chartSettings } = await api.chartSetting
        .updateChartSettings({ measuringPointId, chart, configs });
      // 合并图表配置项
      commit('MERGE_CHART_SETTINGS', chartSettings);
      return chartSettings;
    },
  },
  mutations: {
    MERGE_CHART_SETTINGS(state, chartSettings) {
      for (let i = 0; i < chartSettings.length; i += 1) {
        const { measuringPointId, chart, label } = chartSettings[i];
        const target = state.allChartSettings.find((item) => {
          return item.measuringPointId === measuringPointId
            && item.chart === chart
            && item.label === label;
        });

        if (target) {
          Object.assign(target, chartSettings[i]);
        } else {
          state.allChartSettings.push(chartSettings[i]);
        }
      }
    },
  },
};
